import { Vue, Options } from 'vue-class-component';
import {
  PlantDetailDTO,
  PlantRoomCount,
} from '@/../client-generator/generated-clients/plants';
import DialogPlantCreateStep3 from '@/views/pages/PlantsHub/DialogPlantCreate/WizardAutomationPlant/DialogAutomationPlantCreate/DialogPlantCreateStep3/DialogPlantCreateStep3.vue';
import { PropType } from 'vue';
import plantsClient from '@/core/services/plants';
import { cloneObject, defaultNewPlant } from '@/core/utils/utils';
import { FETCH_PLANT, HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import { NamingService } from '../../../../../core/services/naming.service';

@Options({
  name: 'DialogStructureCreate',
  components: {
    DialogPlantCreateStep3,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    currentPlant: {
      type: Object as PropType<PlantDetailDTO>,
      required: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
      if (this.isEditMode && this.isDialogVisible) this.resetRoomsCount();
    },
  },
  emits: ['hide-dialog', 'update-list'],
})
export default class DialogStructureCreate extends Vue {
  isEditMode!: boolean;
  currentPlant!: PlantDetailDTO;
  isVisible!: boolean;
  isDialogVisible = false;
  isLoading = false;

  plant = cloneObject(defaultNewPlant);

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.resetRoomsCount();
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.resetRoomsCount();
    this.$emit('hide-dialog');
  }

  async handleButtonSubmitAction() {
    await this.handleAddRooms();

    this.isDialogVisible = false;
    this.resetRoomsCount();

    this.$nextTick(async () => {
      this.$emit('update-list');

      this.$toast.add({
        severity: 'success',
        summary: this.$t('AppResource.RoomCreated'),
        closable: false,
        life: 3000,
      });
      const summary = this.$t('general.synced');
      setTimeout(() => {
        this.$toast.add({
          severity: 'success',
          summary: summary,
          closable: false,
          life: 3000,
        });
      }, 1500);
    });
  }

  async handleAddRooms() {
    if (!this.plant.roomsCounts || !this.currentPlant.desktopId) return;

    this.isLoading = true;

    try {
      const request = this.plant.roomsCounts?.filter(
        (room) => (room.count as number) > 0
      );

      await plantsClient.roomsPOST(this.currentPlant.desktopId, request);
      this.$emitter.emit(FETCH_PLANT);
    } catch (error) {
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      NamingService.flushCache();
      this.isLoading = false;
    }
  }

  resetRoomsCount() {
    this.plant.roomsCounts?.forEach((p) => (p.count = 0));
  }

  handleLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
}
